import { defineComponent as I, computed as i, openBlock as n, createBlock as d, unref as b, normalizeClass as v, withCtx as P, createElementBlock as g, createElementVNode as s, renderSlot as y, resolveDynamicComponent as x, toRaw as k, createCommentVNode as c, Fragment as M } from "vue";
import { RevButtonBase as A } from "@ds/components/ButtonBase";
import { RevSpinner as w } from "@ds/components/Spinner";
import { usePropsValidation as E } from "../../composables/usePropsValidation.js";
import R from "../../icons/generated/IconWarning.vue2.js";
import { useI18n as V } from "@ds/plugin";
import T from "../../translations/generic.translations.js";
import { tw as e } from "../../utils/tailwind.js";
import { destructiveVariants as $, MEDIUM_ICON_NAMES as j } from "./Button.constant.js";
const O = {
  key: 0,
  class: "pointer-events-none flex items-center truncate"
}, W = { class: "body-2-bold pointer-events-none truncate" }, F = ["aria-hidden"], U = { class: "body-1-bold truncate px-4" }, _ = /* @__PURE__ */ I({
  name: "RevButton",
  __name: "Button",
  props: {
    ariaDescribedby: { default: () => {
    } },
    ariaLabelledby: { default: () => {
    } },
    ariaLabel: { default: () => {
    } },
    disabled: { type: Boolean, default: !1 },
    fullWidth: { default: "never" },
    icon: { default: () => {
    } },
    iconPosition: { default: "end" },
    loading: { type: Boolean, default: !1 },
    loadingAlternativeText: { default: () => {
    } },
    size: { default: "medium" },
    to: { default: () => {
    } },
    variant: {},
    tracking: { default: () => {
    } }
  },
  emits: ["click"],
  setup(a, { emit: D }) {
    const C = D, S = V(), m = i(
      () => a.loadingAlternativeText || S(T.buttonLoading)
    ), l = i(() => a.disabled || a.loading), B = i(() => l.value ? "" : a.to);
    function z(t) {
      l.value || C("click", t);
    }
    const o = i(() => a.size === "small"), f = i(() => $.includes(a.variant)), u = i(() => {
      const t = a.icon?.name;
      return !!t && j[a.iconPosition].includes(t);
    }), r = i(() => o.value ? a.icon : f.value ? R : u.value ? a.icon : void 0), L = i(() => o.value ? "end" : f.value ? "start" : u.value && a.iconPosition ? a.iconPosition : "end"), N = i(() => [
      e`focus-visible-outline-default-hi rounded-sm relative max-w-full select-none no-underline motion-safe:ease-in`,
      o.value ? [
        e`inline-flex items-center justify-center  motion-safe:transition motion-safe:duration-300`,
        (a.variant === "primary" || a.variant === "primaryDestructive" || a.variant === "primarySuccess" || a.variant === "brand") && e`px-12 py-6`,
        (a.variant === "secondary" || a.variant === "secondaryDestructive" || a.variant === "secondarySuccess") && e`px-11 py-5`
      ] : [
        e`inline-block w-auto hover:no-underline motion-safe:transition-colors motion-safe:duration-200`,
        a.loading && e`overflow-hidden`,
        (a.variant === "primary" || a.variant === "primaryDestructive" || a.variant === "primarySuccess" || a.variant === "brand") && e`p-12`,
        (a.variant === "secondary" || a.variant === "secondaryDestructive" || a.variant === "secondarySuccess") && e`p-11`
      ],
      {
        always: e`w-full`,
        never: "",
        adaptive: e`w-full min-w-80 md:w-auto`
      }[a.fullWidth],
      l.value ? e`cursor-not-allowed` : e`cursor-pointer`,
      {
        primary: [
          e`bg-action-default-hi text-onaction-default-hi`,
          e`hover:bg-action-default-hi-hover`,
          e`disabled:bg-action-default-hi-disabled disabled:text-onaction-default-hi-disabled`
        ],
        primaryDestructive: [
          e`bg-action-danger-hi text-onaction-danger-hi`,
          e`hover:bg-action-danger-hi-hover`,
          e`disabled:bg-action-danger-hi-disabled disabled:text-onaction-danger-hi-disabled`
        ],
        primarySuccess: [
          e`bg-action-success-hi text-onaction-success-hi`,
          e`hover:bg-action-success-hi-hover`,
          e`disabled:bg-action-default-hi-disabled disabled:text-onaction-default-hi-disabled`
        ],
        secondary: [
          e`bg-action-default-min border-action-default-hi`,
          e`text-action-default-hi border border-solid`,
          e`hover:bg-action-default-min-hover`,
          e`disabled:bg-action-default-min-disabled disabled:border-action-default-hi-disabled disabled:text-onaction-default-hi-disabled`
        ],
        secondaryDestructive: [
          e`bg-action-danger-min border-action-danger-hi`,
          e`text-action-danger-hi border border-solid`,
          e`hover:bg-action-danger-min-hover`,
          e`disabled:bg-action-danger-min-disabled disabled:border-action-default-hi-disabled disabled:text-onaction-danger-hi-disabled`
        ],
        secondarySuccess: [
          e`bg-action-success-min border-action-success-hi`,
          e`text-action-success-hi border border-solid`,
          e`hover:bg-action-success-min-hover`,
          e`disabled:bg-action-success-min-disabled disabled:border-action-default-hi-disabled disabled:text-onaction-danger-hi-disabled`
        ],
        brand: [
          e`bg-action-brand-low text-onaction-brand-low`,
          e`hover:bg-action-brand-low-hover`,
          e`disabled:opacity-40`
        ]
      }[a.variant]
    ]), h = i(() => [
      e`pointer-events-none flex items-center`,
      o.value ? e`gap-x-8` : e`justify-center`,
      a.loading && e`invisible`,
      L.value === "start" && e`flex-row-reverse`
    ]);
    return E({
      "Medium size button `icon` must be from the supported list": () => a.size === "medium" && !u.value
    }), (t, q) => (n(), d(b(A), {
      "aria-describedby": a.ariaDescribedby,
      "aria-disabled": l.value,
      "aria-label": a.ariaLabel,
      "aria-labelledby": a.ariaLabelledby,
      class: v(N.value),
      disabled: a.disabled,
      to: B.value,
      tracking: a.tracking,
      onClick: z
    }, {
      default: P(() => [
        o.value ? (n(), g("span", O, [
          s("span", {
            class: v(["truncate", h.value])
          }, [
            s("span", W, [
              y(t.$slots, "default")
            ]),
            r.value ? (n(), d(x(k(r.value)), {
              key: 0,
              class: "shrink-0",
              size: "small"
            })) : c("", !0)
          ], 2),
          a.loading ? (n(), d(b(w), {
            key: 0,
            "alternative-text": m.value,
            class: "absolute inset-0 mx-auto h-full",
            size: "small"
          }, null, 8, ["alternative-text"])) : c("", !0)
        ])) : (n(), g(M, { key: 1 }, [
          a.loading ? (n(), d(b(w), {
            key: 0,
            "alternative-text": m.value,
            class: "absolute inset-0 m-auto w-full"
          }, null, 8, ["alternative-text"])) : c("", !0),
          s("span", {
            "aria-hidden": a.loading,
            class: v(h.value)
          }, [
            s("span", U, [
              y(t.$slots, "default")
            ]),
            r.value ? (n(), d(x(k(r.value)), {
              key: 0,
              class: "shrink-0",
              size: "medium"
            })) : c("", !0)
          ], 10, F)
        ], 64))
      ]),
      _: 3
    }, 8, ["aria-describedby", "aria-disabled", "aria-label", "aria-labelledby", "class", "disabled", "to", "tracking"]));
  }
});
export {
  _ as default
};
